import { GatewayInstallationComponent } from "../../routes/Admin/clients/network-config/gateway/installation/installation.component";
import { GatewayFormComponent } from "../../routes/Admin/clients/network-config/gateway/form/form.component";
import { NetworkGatewayComponent } from "../../routes/Admin/clients/network-config/gateway/gateway";

import { OffsidebarComponent } from "./offsidebar/offsidebar.component";
import { ComponentsModule } from "../../components/components.module";
import { AgmCoreModule, GoogleMapsAPIWrapper } from "@agm/core";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { HeaderComponent } from "./header/header.component";
import { ImageCropperModule } from "ngx-image-cropper";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LayoutComponent } from "./layout.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ModalsComponent } from "./modals/modals";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ProfileComponent } from "./sidebar/profile/profile";
import { ConfigurationOffsidebarComponent } from "./offsidebar/configuration/configuration";
import { OtherConfigurationOffsidebarComponent } from "./offsidebar/other-configuration/other-configuration";

@NgModule({
  imports: [
    AgmCoreModule,
    ReactiveFormsModule,
    FormsModule,
    ImageCropperModule,
    ComponentsModule,
    NgbModule,
    TranslateModule
  ],
  providers: [GoogleMapsAPIWrapper],
  declarations: [
    GatewayInstallationComponent,
    NetworkGatewayComponent,
    GatewayFormComponent,
    OffsidebarComponent,
    SidebarComponent,
    LayoutComponent,
    HeaderComponent,
    ModalsComponent,
    ProfileComponent,
    ConfigurationOffsidebarComponent,
    OtherConfigurationOffsidebarComponent
  ],
  exports: [
    OffsidebarComponent,
    SidebarComponent,
    LayoutComponent,
    HeaderComponent,
    ModalsComponent
  ]
})
export class LayoutModule {}
